import type { ImportEntity } from './contract';

/**
 * `?import=customers` on the customers page and `?import=deals` on the deals page open the
 * import drawer over the list (spec 007 §7.2). The value must match the page: any other value
 * is dropped, never an error page.
 */
export type ImportSearch<E extends ImportEntity> = { import?: E };

export function parseImportSearch<E extends ImportEntity>(
  raw: Record<string, unknown>,
  entity: E,
): ImportSearch<E> {
  return raw['import'] === entity ? { import: entity } : {};
}

/** The page state without the drawer: what the list itself reads. */
export function withoutImport<S extends { import?: ImportEntity }>(search: S): Omit<S, 'import'> {
  const { import: _drawer, ...rest } = search;
  return rest;
}
